<!-- TODO: COMPONETIZE! -->
<div class="unh-dialog-nav__control prev">
    <button 
        mat-icon-button aria-label="Gallery Navigation Right Button"
        [disabled]="!rtlButtonEnabled"
        (click)="navButtonClicked.emit('rtl')"
    >
        <!-- <mat-icon *ngIf="isSmallScreen">chevron_left</mat-icon> -->
        <mat-icon svgIcon="unh_round_tipped_left_arrow" inline="true"></mat-icon>
    </button>
</div>

<div class="unh-dialog-nav__control next">
    <button 
        mat-icon-button aria-label="Gallery Navigation Right Button"
        [disabled]="!ltrButtonEnabled"
        (click)="navButtonClicked.emit('ltr')"
    >
        <!-- <mat-icon style="font-size: 48px" *ngIf="isSmallScreen">chevron_right</mat-icon> -->
        <mat-icon svgIcon="unh_round_tipped_right_arrow" inline="true"></mat-icon>
    </button>
</div>